import { useState, useEffect } from "react";

export enum ScreenSizeEnum {
  LargeDesktop,
  Desktop,
  Mobile,
}

export const useScreenSize = () => {
  const useViewportBreakPointToDesktop = 600;
  const useViewportBreakPointToLargeDesktop = 1200;
  //Because of issues with landscape mode on mobile, we now check the shortest side of the screen, and if it is below 480px, we consider it a mobile device. 
  const phoneShortSideThreshold = 480;

  

  const getSize = (): ScreenSizeEnum => {
    const shortSide = Math.min(window.innerWidth, window.innerHeight);
    if (shortSide <= phoneShortSideThreshold) {
      return ScreenSizeEnum.Mobile;
    }
    if (window.innerWidth > useViewportBreakPointToLargeDesktop) {
      return ScreenSizeEnum.LargeDesktop;
    }
    if (window.innerWidth > useViewportBreakPointToDesktop) {
      return ScreenSizeEnum.Desktop;
    }
    return ScreenSizeEnum.Mobile;
  };

  const [screenSize, setScreenSize] = useState(getSize());

  useEffect(() => {
    const handleWindowResize = () => setScreenSize(getSize());
    window.addEventListener("resize", handleWindowResize);
    window.addEventListener("orientationchange", handleWindowResize);
    return () => {
      window.removeEventListener("resize", handleWindowResize);
      window.removeEventListener("orientationchange", handleWindowResize);
    };
  }, []);

  return { screenSize };
};
